import { Fragment } from 'react'
import PropTypes from 'prop-types'
import useIsMobile from '../../../../../hooks/useIsMobile'
import { Box, Chip } from '@mui/material'

import useTranslations from '../../../../../i18n/useTranslations'
import { ReactComponent as Success } from '../../../../../assets/icons/success.svg'
import { ReactComponent as PackageClose } from '../../../../../assets/icons/package-close.svg'
import { ReactComponent as Weight } from '../../../../../assets/icons/weight.svg'
import { ReactComponent as MapPin } from '../../../../../assets/icons/map-pin.svg'
import { SERVICES_NAMES } from '../../../../../common/constants'

const ShippingConfigChips = ({
  numberOfPackages,
  serviceType,
  totalWeight,
  services,
}) => {
  const t = useTranslations()

  const isMobile = useIsMobile()

  const ChipsWrapper = isMobile ? Box : Fragment

  return (
    <>
      <ChipsWrapper>
        <Chip
          className="purple"
          avatar={<PackageClose />}
          label={
            <>
              <strong>{numberOfPackages}</strong> {t('noun:total-packages')}
            </>
          }
        />
        <Chip
          className="purple"
          avatar={<Weight />}
          label={
            <>
              <strong>
                {t('placeholder:kilograms', {
                  number: totalWeight,
                })}
              </strong>{' '}
              {t('noun:-appraisal-weight')}
            </>
          }
        />
        <Chip
          className="purple"
          avatar={<MapPin />}
          label={
            <>
              <strong>
                {SERVICES_NAMES.hasOwnProperty(serviceType)
                  ? SERVICES_NAMES[serviceType]
                  : serviceType}
              </strong>
            </>
          }
        />
      </ChipsWrapper>
      {services?.map(service => (
        <Chip
          key={service.title}
          className="green"
          avatar={<Success />}
          label={
            <>
              {t(service.title)}{' '}
              <strong>
                {service.value}
                {service.extraInfo ? t(service.extraInfo) : null}
              </strong>
            </>
          }
        />
      ))}
    </>
  )
}

ShippingConfigChips.propTypes = {
  numberOfPackages: PropTypes.number,
  serviceType: PropTypes.string,
  totalWeight: PropTypes.number,
  services: PropTypes.array,
}

export default ShippingConfigChips
